import { gql } from "@apollo/client";

const ENABLE_RENEW_SUBSCRIPTION = gql`
  mutation EnableRenewSubscription {
    enableSubscriptionRenew {
      subscription {
        id
        status
        renew
      }
    }
  }
`;

export default ENABLE_RENEW_SUBSCRIPTION;
